import { call, put, select } from "redux-saga/effects"
import {
  getProjectId,
  getProjectStatus,
  getProjectEndDate,
  getProjectsBackerUUID,
} from "../reducers/projects"
import { withinLast7Days } from "../utils/dates"
import { isLive } from "../utils/project"
import { updatePixelFiredAt } from "../actions"
import { buildReddit } from "../utils/reddit-pixel"

export default function* handleRedditTracking({ payload }) {
  const uuid = yield select(getProjectsBackerUUID)
  const projectId = yield select(getProjectId)
  const projectStatus = yield select(getProjectStatus)
  const projectEndDate = yield select(getProjectEndDate)

  if (isLive(projectStatus) || withinLast7Days(projectEndDate)) {
    yield call(buildReddit, payload.data, `${projectId}-survey-${uuid}`)

    yield put(updatePixelFiredAt())
  }
}
